import max from 'lodash/max';

const MAX_ATTEMPTS = 3;

export const canSubmitExercise = (nbAttempts: any) => nbAttempts < MAX_ATTEMPTS;
export const formatTitle = (nbAttempts: any, title: any) =>
  `${title} (${max([MAX_ATTEMPTS - nbAttempts, 0])})`;
export const isExamExercise = (exerciseType: any) =>
  exerciseType === 'ExamExercise';
